"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheTribeVibe() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const archiveItems = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_summer_camp_fire.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_summer_camp_fire.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_summer_camp_fire.png-wvc-sizes",
    alt: "Youth Tribe summer camp campfire night",
    nameEn: "Summer Camp",
    nameJp: "Campfire",
    date: "MMXXIV — 08",
    technique: "Building community through shared stories and late-night campfires.",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_team_sports_action.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_team_sports_action.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_team_sports_action.webp-wvc-sizes",
    alt: "Youth Tribe team sports competition",
    nameEn: "Team Sports",
    nameJp: "Competition",
    date: "MMXXIV — 07",
    technique: "Developing leadership and teamwork on the field every weekend.",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_live_music_night.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_live_music_night.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_live_music_night.png-wvc-sizes",
    alt: "Youth Tribe live music performance",
    nameEn: "Live Music",
    nameJp: "Performance",
    date: "MMXXIV — 06",
    technique: "Showcasing local youth talent in our high-energy music sessions.",
    aspect: "aspect-[4/5]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_friday_social_event.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_friday_social_event.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_friday_social_event.png-wvc-sizes",
    alt: "Youth Tribe Friday night social",
    nameEn: "Friday Social",
    nameJp: "Gathering",
    date: "MMXXIV — 05",
    technique: "Weekly social events designed to foster lasting friendships.",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_small_group_discussion.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_small_group_discussion.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_small_group_discussion.png-wvc-sizes",
    alt: "Youth Tribe small group discussion",
    nameEn: "Small Groups",
    nameJp: "Mentorship",
    date: "MMXXIV — 04",
    technique: "Meaningful conversations that guide personal growth and values.",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_volunteer_project.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_volunteer_project.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_volunteer_project.png-wvc-sizes",
    alt: "Youth Tribe community volunteer project",
    nameEn: "Volunteering",
    nameJp: "Service",
    date: "MMXXIV — 03",
    technique: "Giving back to our community through hands-on service projects.",
    aspect: "aspect-[4/5]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_outdoor_adventure.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_outdoor_adventure.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_outdoor_adventure.png-wvc-sizes",
    alt: "Youth Tribe outdoor adventure hike",
    nameEn: "Adventure",
    nameJp: "Exploration",
    date: "MMXXIV — 02",
    technique: "Challenging ourselves in the great outdoors together.",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_creative_workshop.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_creative_workshop.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_creative_workshop.png-wvc-sizes",
    alt: "Youth Tribe creative workshop",
    nameEn: "Creativity",
    nameJp: "Expression",
    date: "MMXXIV — 01",
    technique: "Unlocking potential through art, music, and creative expression.",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_leadership_training.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_leadership_training.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_leadership_training.png-wvc-sizes",
    alt: "Youth Tribe leadership training session",
    nameEn: "Leadership",
    nameJp: "Growth",
    date: "MMXXIII — 12",
    technique: "Empowering the next generation of community leaders.",
    aspect: "aspect-[4/5]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_community_dinner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_community_dinner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_community_dinner.png-wvc-sizes",
    alt: "Youth Tribe community dinner",
    nameEn: "Community",
    nameJp: "Connection",
    date: "MMXXIII — 11",
    technique: "Sharing meals and building a stronger, inclusive tribe.",
    aspect: "aspect-[3/4]"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_sports_tournament.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_sports_tournament.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_sports_tournament.webp-wvc-sizes",
    alt: "Youth Tribe sports tournament",
    nameEn: "Tournament",
    nameJp: "Action",
    date: "MMXXIII — 10",
    technique: "High-energy sports tournaments that bring everyone together.",
    aspect: "aspect-square"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_mentorship_program.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_mentorship_program.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_mentorship_program.png-wvc-sizes",
    alt: "Youth Tribe mentorship program",
    nameEn: "Mentorship",
    nameJp: "Guidance",
    date: "MMXXIII — 09",
    technique: "Connecting youth with mentors for life-long support.",
    aspect: "aspect-[4/5]"
  }];
  return <section data-section-id="3532" id="the-tribe-vibe" className="dark bg-background text-foreground py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={introRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16 md:mb-20 lg:mb-24 transition-all duration-1000 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] mb-8" style={{
            color: "var(--chart-2)"
          }}>THE TRIBE VIBE</p>
            <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
              <span className="block text-foreground">Captured moments of</span>
              <span className="block italic text-primary">energy and connection.</span>
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pt-6 flex lg:justify-end">
            <div className="max-w-[360px]">
              <div className="w-10 h-px bg-primary mb-6" aria-hidden="true" />
              <p className="font-default text-base md:text-[15px] leading-relaxed text-muted-foreground">
                A living gallery of the Youth Tribe experience—from summer camp highlights to 
                intense team sports and live music nights. Each entry captures the spirit 
                of our community, our growth, and our shared journey together.
              </p>
              
            </div>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`columns-2 md:columns-3 lg:columns-4 gap-4 md:gap-6 transition-opacity duration-1000 ${gridVisible ? "opacity-100" : "opacity-0"}`}>
          {archiveItems.map((item, i) => <figure key={i} data-index={i} className="group break-inside-avoid mb-4 md:mb-6">
              <div className="relative overflow-hidden p-2 transition-all duration-500 ease-out group-hover:-translate-y-1" style={{
            backgroundColor: "var(--card)",
            border: "1px solid var(--border)"
          }}>
                <div className={`relative overflow-hidden ${item.aspect}`}>
                  <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" />
                  {}
                  <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out p-4 md:p-5" style={{
                background: "linear-gradient(to top, hsl(226 60% 8%) 0%, hsl(226 60% 8% / 0.85) 70%, transparent 100%)"
              }}>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-2" style={{
                  color: "var(--chart-2)"
                }}>
                      Activity
                    </p>
                    <p className="font-default text-sm md:text-[15px] leading-snug text-white">
                      {item.technique}
                    </p>
                  </div>
                </div>
              </div>

              <figcaption className="pt-3 md:pt-4 px-1">
                <div className="flex items-baseline justify-between gap-3">
                  <p className="font-default text-sm md:text-[15px] text-foreground leading-tight">
                    {item.nameEn}
                    <span className="text-muted-foreground"> — {item.nameJp}</span>
                  </p>
                </div>
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-primary mt-1.5">
                  {item.date}
                </p>
              </figcaption>
            </figure>)}
        </div>

        {}
        <div className="flex justify-center mt-16 md:mt-20">
          <Button asChild variant="ghost" className="font-mono text-xs uppercase tracking-[0.25em] h-auto py-4 px-8 border border-primary hover:border-primary/60 hover:bg-primary text-white hover:text-white transition-colors duration-500">
            <Link to="/ParentHubPage">
              Download Registration Forms
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>

        {}
        
      </div>
    </section>;
}